import { channel, buffers } from 'redux-saga';
import {
  call,
  fork,
  put,
  take,
  flush,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import {
  UPLOAD_FILE,
  CROP_RESOURCE,
  CANCEL_PENDING,
  uploadingFile,
  uploadFileSuccess,
  uploadFileFailure,
} from '../actions/uploads';
import { MAX_CONCURRENT_UPLOADS } from '../constants';
import * as Api from '../api/uploads';

const INIT_BUFFER_SIZE = 20;

// We don't fear overflow here, so using expanding buffer is not dangerous
const createUploadChannel = () => channel(buffers.expanding(INIT_BUFFER_SIZE));

function* watchUploads() {
  const chan = yield call(createUploadChannel);

  // Creating workers (up to max)
  for (var i = 0; i < MAX_CONCURRENT_UPLOADS; i++) {
    yield fork(handleUpload, chan);
  }

  // Adding next calls to pending
  yield takeEvery(UPLOAD_FILE, addPendingUpload, chan);
  yield takeEvery(CROP_RESOURCE, addPendingCrop, chan);

  // Handling pending cancellation
  yield takeLatest(CANCEL_PENDING, cancelPending, chan);
}

function* addPendingUpload(chan, upload) {
  yield put(chan, upload);
}

function* addPendingCrop(chan, crop) {
  yield put(chan, crop);
}

function* cancelPending(chan) {
  // Cancelling all pending uploads by flushing channel buffer
  yield flush(chan);
}

function* handleUpload(chan) {
  while (true) {
    const { folder, upload, resource, crop } = yield take(chan);

    try {
      yield put(uploadingFile(folder, upload));

      let response;
      if (crop) {
        // Creating resource from crop
        response = yield call(Api.crop, folder.id, resource.id, crop);
      } else {
        // Uploading file
        response = yield call(Api.upload, folder.id, upload.file);
      }

      yield put(uploadFileSuccess(folder, upload, response));
    } catch (error) {
      yield put(uploadFileFailure(folder, upload, error));
    }
  }
}

export default function* root() {
  yield [fork(watchUploads)];
}



// WEBPACK FOOTER //
// ./src/modules/bucket/sagas/uploads.js